import React from 'react'
import type { MembershipTier } from '../../types/membership'

interface MembershipBadgeProps {
  tier: MembershipTier
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
}

const tierConfig: Record<MembershipTier, { label: string; classes: string }> = {
  none: {
    label: 'Peserta',
    classes: 'bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-white/10',
  },
  bronze: {
    label: 'Bronze',
    classes: 'bg-amber-100 dark:bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-500/20',
  },
  silver: {
    label: 'Silver',
    classes: 'bg-gray-100 dark:bg-gray-400/10 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-400/20',
  },
  gold: {
    label: 'Gold',
    classes: 'bg-yellow-100 dark:bg-yellow-500/10 text-yellow-700 dark:text-yellow-300 border-yellow-200 dark:border-yellow-500/20',
  },
  platinum: {
    label: 'Platinum',
    classes: 'bg-gray-200 dark:bg-gray-300/10 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-300/20',
  },
  vip: {
    label: 'VIP',
    classes: 'bg-gradient-to-r from-purple-100 to-pink-100 dark:from-purple-500/10 dark:to-pink-500/10 text-purple-700 dark:text-purple-300 border-purple-200 dark:border-purple-500/20',
  },
}

const sizeClasses: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'px-2.5 py-0.5 text-[10px]',
  md: 'px-3 py-1 text-xs',
  lg: 'px-4 py-1.5 text-sm',
}

export const MembershipBadge: React.FC<MembershipBadgeProps> = ({
  tier,
  size = 'md',
  showLabel = true,
}) => {
  const config = tierConfig[tier]

  return (
    <span
      className={`inline-flex items-center font-bold rounded-full border ${config.classes} ${sizeClasses[size]}`}
    >
      {showLabel && config.label}
    </span>
  )
}
